<div class="mT15 mB40">
    <span
        class="name-exists-container"
    >
        {{ title | translate:{existingName} }}
        <br>
        <br>
        {{ body | translate:{existingName} }}<strong>{{suggestedPrefix}}</strong>.
    </span>
</div>